import axios from 'axios'

const TicaoDao = {
  async list () {
    const url = '/programme/find/all_course'
    const { data: resp } = await axios.get(url)
    const {
      code,
      data
    } = resp
    if (code !== 200 || !data) {
      return null
    }
    return data
  },
  // /programme/CourseApplet/find/all_course // 小程序课程
  async listApplet () {
    const url = '/programme/CourseApplet/find/all_course'
    const { data: resp } = await axios.get(url)
    const {
      code,
      data
    } = resp
    if (code !== 200 || !data) {
      return null
    }
    return data
  },
  // 根据id 查询课程详情 /programme/CourseApplet/find/one
  async findOne (id) {
    const url = '/programme/CourseApplet/find/one'
    const { data: resp } = await axios.get(url, {
      params: {
        courseId: id
      }
    })
    const {
      code,
      data
    } = resp
    if (code !== 200 || !data) {
      return null
    }
    return data
  },
  // 保存观看历史
  async saveWatchHistory (payload) {
    const url = '/programme/save/watch_history'
    const { data: resp } = await axios.post(url, payload)
    const { code } = resp || {}
    return code === 200
  },
  // 读取观看过的课程-我的学习课程
  async listAppletMyCourse (userId) {
    const url = '/programme/load/watch_history'
    const { data: resp } = await axios.get(url, {
      params: {
        userId: userId
      }
    })
    const {
      code,
      data
    } = resp
    if (code !== 200 || !data) {
      return null
    }
    return data
  },
  // 读取观看过的训练方案记录
  async listAppletMyPlan (userId) {
    const url = '/programme/load/watch_history/v2'
    const { data: resp } = await axios.get(url, {
      params: {
        userId: userId
      }
    })
    const {
      code,
      data
    } = resp
    if (code !== 200 || !data) {
      return null
    }
    return data
  },
}
export default TicaoDao
